import React from 'react';

const ChatTargetSidebarToolbar = ({
  onOpenSearch,
  searchLabel = '検索',
  summary = '',
  chips = [],
  toggles = [],
  children = null,
}) => (
  <div className="chat-target-sidebar-toolbar">
    <div className="chat-target-sidebar-toolbar__actions">
      <button
        type="button"
        className="chat-target-sidebar-toolbar__button is-main"
        onClick={onOpenSearch}
      >
        {searchLabel}
      </button>
      {Array.isArray(toggles) && toggles.length > 0
        ? toggles.map((toggle) => (
            <button
              key={toggle.key}
              type="button"
              className={`chat-target-sidebar-toolbar__button is-sub chat-target-sidebar-toolbar__toggle${toggle.active ? ' is-active' : ''}`}
              onClick={toggle.onClick}
              aria-pressed={!!toggle.active}
            >
              {toggle.label}
            </button>
          ))
        : null}
      {children}
    </div>
    {summary ? <div className="chat-target-sidebar-toolbar__summary">{summary}</div> : null}
    {Array.isArray(chips) && chips.length > 0 ? (
      <div className="chat-target-sidebar-toolbar__chips" aria-label="適用中の検索条件">
        {chips.map((chip) => {
          const isAction = typeof chip?.onRemove === 'function';
          const className = [
            'chat-target-sidebar-toolbar__chip',
            isAction ? 'is-action' : '',
            chip?.variant === 'clear-all' ? 'is-clear-all' : '',
          ]
            .filter(Boolean)
            .join(' ');
          if (!isAction) {
            return (
              <span key={chip.key} className={className}>
                <span className="chat-target-sidebar-toolbar__chip-label">{chip.text}</span>
              </span>
            );
          }
          return (
            <button
              key={chip.key}
              type="button"
              className={className}
              onClick={chip.onRemove}
              aria-label={chip.ariaLabel || chip.text}
            >
              <span className="chat-target-sidebar-toolbar__chip-label">{chip.text}</span>
              {chip?.variant !== 'clear-all' ? (
                <span className="chat-target-sidebar-toolbar__chip-remove" aria-hidden="true">
                  ×
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    ) : null}
  </div>
);

export default ChatTargetSidebarToolbar;
